module.exports = __webpack_public_path__ + "img/J8.6a853cfa.png";